var _rect, _path, _rect2, _g, _path2, _path3, _path4, _path5, _path6, _path7, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3369)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H23V23H0V0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2402_3369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2402_3369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44055 12.4582L1.40638 14.123L13.0021 1.81011L14.5038 -0.663855L11.4594 -1.22029L6.7298 4.08571L2.92294 7.66071L-1.44055 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05078 13.6247L0.3996 14.5908L13.9646 -0.893656H11.9281L-1.05078 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-9-outside-1_2402_3369",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 0V-0.75H4.98887V0H5.73887ZM7.17637 0H7.92637V-0.75H7.17637V0ZM5.73887 5.75V6.5H6.48887V5.75H5.73887ZM0 5.75V5H-0.75V5.75H0ZM0 7.66667H-0.75V8.41667H0V7.66667ZM5.73887 7.66667H6.48887V6.91667H5.73887V7.66667ZM5.73887 13.4167H4.98887V14.1667H5.73887V13.4167ZM7.17637 13.4167V14.1667H7.92637V13.4167H7.17637ZM7.17637 7.66667V6.91667H6.42637V7.66667H7.17637ZM12.9375 7.66667V8.41667H13.6875V7.66667H12.9375ZM12.9375 5.75H13.6875V5H12.9375V5.75ZM7.17637 5.75H6.42637V6.5H7.17637V5.75ZM5.73887 0.75H7.17637V-0.75H5.73887V0.75ZM6.48887 5.75V0H4.98887V5.75H6.48887ZM0 6.5H5.73887V5H0V6.5ZM0.75 7.66667V5.75H-0.75V7.66667H0.75ZM5.73887 6.91667H0V8.41667H5.73887V6.91667ZM6.48887 13.4167V7.66667H4.98887V13.4167H6.48887ZM7.17637 12.6667H5.73887V14.1667H7.17637V12.6667ZM6.42637 7.66667V13.4167H7.92637V7.66667H6.42637ZM12.9375 6.91667H7.17637V8.41667H12.9375V6.91667ZM12.1875 5.75V7.66667H13.6875V5.75H12.1875ZM7.17637 6.5H12.9375V5H7.17637V6.5ZM6.42637 0V5.75H7.92637V0H6.42637Z",
    fill: "#F7FCFF",
    mask: "url(#path-9-outside-1_2402_3369)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72054 15.7507L8.13011 16.2963L8.18858 15.4945L7.39386 15.3731L8.0572 14.9189L7.65662 14.2218L8.42533 14.4573L8.72054 13.7095L9.01576 14.4573L9.78446 14.2218L9.38388 14.9189L10.0472 15.3731L9.2525 15.4945L9.31097 16.2963L8.72054 15.7507Z",
    fill: "#F7FCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0885 11.9853L14.6949 12.3491L14.7338 11.8145L14.204 11.7336L14.6462 11.4308L14.3792 10.9661L14.8917 11.123L15.0885 10.6245L15.2853 11.123L15.7978 10.9661L15.5307 11.4308L15.9729 11.7336L15.4431 11.8145L15.4821 12.3491L15.0885 11.9853Z",
    fill: "#F7FCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0272 8.29342L15.6336 8.65718L15.6726 8.12263L15.1427 8.04169L15.585 7.73888L15.3179 7.27419L15.8304 7.43114L16.0272 6.93262L16.224 7.43114L16.7365 7.27419L16.4694 7.73888L16.9116 8.04169L16.3818 8.12263L16.4208 8.65718L16.0272 8.29342Z",
    fill: "#F7FCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3739 10.1391L17.9803 10.5029L18.0192 9.96834L17.4894 9.88739L17.9316 9.58458L17.6646 9.11989L18.1771 9.27684L18.3739 8.77832L18.5707 9.27684L19.0832 9.11989L18.8161 9.58458L19.2583 9.88739L18.7285 9.96834L18.7675 10.5029L18.3739 10.1391Z",
    fill: "#F7FCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4966 15.4472L16.1029 15.811L16.1419 15.2764L15.6121 15.1955L16.0543 14.8927L15.7873 14.428L16.2997 14.5849L16.4966 14.0864L16.6934 14.5849L17.2058 14.428L16.9388 14.8927L17.381 15.1955L16.8512 15.2764L16.8902 15.811L16.4966 15.4472Z",
    fill: "#F7FCFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1391 12.5645L17.7392 12.7748L17.8156 12.3295L17.492 12.0141L17.9392 11.9491L18.1391 11.5439L18.3391 11.9491L18.7862 12.0141L18.4627 12.3295L18.5391 12.7748L18.1391 12.5645Z",
    fill: "#F7FCFF"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3369)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3369",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAud);
export default __webpack_public_path__ + "static/media/AUD.7052216ae31422aa07e3182e814dbac5.svg";
export { ForwardRef as ReactComponent };